module.exports = __webpack_public_path__ + "media/images/webpage/coupons/coupon/howto-step4-57c5546907fb01f73166fc061c5e1057.svg";